import React from 'react';
import { withTranslation } from 'react-i18next';
import { BsCheck2 } from 'react-icons/bs';
import './ResultPage.scss';

class ResultPage extends React.Component<any, any> {

    scrollInEmployeeSite() {
        if(window.parent) {
            window.parent.postMessage({ budget : this.props.budget }, '*');
        };
    }
    render() {
        return (
            <div className="ResultPage">
                <div className='description'>
                    <p>{this.props.t('BudgetBikeResultDescription1')}</p>
                    <span className='text-important'>{this.props.t('BudgetBikeResultDescription2')} {this.props.budget}</span>
                    <p>{this.props.t('BudgetBikeResultDescription4')}</p>
                    <p><span className='text-important'>{this.props.t('BudgetBikeResultDescription2')} {this.props.monthlyLease}</span> / {this.props.t('BudgetBikeResultDescription5')}</p>
                </div>
                <a className='btnNetImpact' 
                    href='https://docs.google.com/spreadsheets/d/1f__AQxnPrbTtJ149BTWUL6HZdEn4epJfLHZV9vY5MFM/edit?usp=sharing' 
                    target='_blank'
                    rel='noreferrer'
                >
                    <p className='textBtn'>{this.props.t('BudgetBikeResultBtnNetImpact')}</p>
                    <BsCheck2 className='iconBtn'/>
                </a>
                <div className='btnNewSimulation' onClick={this.props.displayRightPage}>
                    <p className='textBtn'>{this.props.t('BudgetBikeResultBtnNewSimulation')}</p>
                    <BsCheck2 className='iconBtn'/>
                </div>
                <div className='rules'>
                    <p>{this.props.t('BudgetBikeResultLastText')}</p>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ResultPage);
